/** Liquid tag with spaces: `{{ contact.first_name }}` */
export const formatLiquidVariable = key => `{{ ${key} }}`;
